import userServices from 'services/user.services';
import { getAuthStore, setAuthStore } from 'stores/auth.store';
import { deCamelizeKeysObjNormalize } from 'helpers/utils';
import { DATA_PER_PAGE, ROWS_PER_PAGE_OPTIONS } from 'constants/common.constant';

/**
 * Merge a patch into one table's settings (e.g. `{ pageSize }` or `{ selectedColumns }`) and save
 * the whole setting blob, keeping sibling keys of that table and other tables intact.
 * Reads the store at call time so back-to-back saves never use stale settings.
 */
export const saveTableSetting = async (filterKey, patch) => {
  const { userData = {} } = getAuthStore();
  const current = userData.setting || {};
  const setting = { ...current, [filterKey]: { ...current[filterKey], ...patch } };

  // The API replaces the whole setting blob and drops keys it does not know.
  // decamelize turns tap2PayEnabled into tap2_pay_enabled, not tap_2_pay_enabled,
  // which would reset the driver's tap to pay preference on every save.
  const payload = deCamelizeKeysObjNormalize(setting);
  if (payload.driver_settings && 'tap2_pay_enabled' in payload.driver_settings) {
    const { tap2_pay_enabled: tap2PayEnabled, ...driverSettings } = payload.driver_settings;
    payload.driver_settings = { ...driverSettings, tap_2_pay_enabled: tap2PayEnabled };
  }

  setAuthStore({ userData: { ...userData, setting } });
  try {
    await userServices.updateUserSetting({ setting: payload });
  } catch (err) {
    // Keep the store in step with the server so a failed save does not look saved.
    setAuthStore({ userData });
    throw err;
  }
};

// Persisted page size of a table, or the default when unset or no longer an offered option.
export const getTablePageSize = (userSettings, filterKey, fallback = DATA_PER_PAGE) => {
  const pageSize = userSettings?.[filterKey]?.pageSize;
  return ROWS_PER_PAGE_OPTIONS.includes(pageSize) ? pageSize : fallback;
};
